import Swiper from './swiper-bundle.js';
class CaseStudyCarousel {
    constructor() {
 
        document.addEventListener("DOMContentLoaded", function(){
            document.querySelectorAll('.block--case-study-carousel').forEach(block => {
                // Initialise Swiper
                const swiper = new Swiper(block.querySelector('.swiper'), {
                    // Optional parameters
                    direction: 'horizontal',
                    // grabCursor: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    },
                });
            });
        });

    }
  }
  export default new CaseStudyCarousel;
  